$(document).ready(function(){

	$('a[href^="#"], .scrollTop a').on('click', function(e){
		e.preventDefault();
		
		var id = $(this).attr("href");
	
		$('html, body').animate({
			scrollTop: $(id).offset().top - 117
		}, 'slow');
		return false;
	});

});